module.exports = __webpack_public_path__ + "img/crusher.1928fbf7.png";